export default __webpack_public_path__ + "img/99fbf72607c31dd283131bfbd2cb6056.png";